import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import { useAuthContext } from "../../../context/AuthContext";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import SubjectSurveyStatistics from "./components/SubjectSurveyStatistics";
import TermSurveyStatistics from "./components/TermSurveyStatistics";
import YearlySurveyStatistics from "./components/YearlySurveyStatistics";

export default function SurveyStatistics() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];

  const { hasPermission } = useAuthContext();

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "subjectSurvey",
    menu_id: "subjectSurvey",
  });

  // 메뉴 데이터 설정
  const menuData = [
    {
      record_name: "subjectSurvey",
      record_label: t("teacher.surveyStatistics.subjectSurvey") || "수업설문",
    },
    // {
    //   record_name: "termSurvey",
    //   record_label: t("teacher.surveyStatistics.termSurvey") || "학기설문",
    // },
    // {
    //   record_name: "yearlySurvey",
    //   record_label: t("teacher.surveyStatistics.yearlySurvey") || "학년도설문",
    // },
  ];

  // 컴포넌트 렌더링 함수
  function renderComponent() {
    switch (activeMenu.menu_name) {
      case "subjectSurvey":
        return <SubjectSurveyStatistics schoolId={schoolId} />;
      case "termSurvey":
        return <TermSurveyStatistics schoolId={schoolId} />;
      case "yearlySurvey":
        return <YearlySurveyStatistics schoolId={schoolId} />;
      default:
        return <SubjectSurveyStatistics schoolId={schoolId} />;
    }
  }

  // 접근 권한 체크
  if (!hasPermission(null, "can_access")) {
    return (
      <SimpleAlertMessageBlock
        message={t("common.messages.noAccessPermission")}
      />
    );
  }

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={menuData}
              itemName="record_name"
              itemLabel="record_label"
            />
          </div>
          <div className="col-12 col-md-10">{renderComponent()}</div>
        </div>
      </div>
    </div>
  );
}
